// @flow

/* -----------------Globals--------------- */
import React from 'react';
/* -----------------------  PLACEHOLDER DATA FOR PREMIUM-STORE PAGES ------------------ */
/* -----------------Assets--------------- */
import Logo7 from '@images/premium/icon_bundle_7.png';
import Logo8 from '@images/premium/icon_bundle_9.png';
import Logo9 from '@images/premium/icon_bundle_10.png';
import Logo10 from '@images/premium/icon_bundle_24.png';
import Logo11 from '@images/premium/icon_bundle_28.png';

import Calendar from '@images/illustrations/calendar.svg';
import Devices from '@images/illustrations/devices.svg';
import Notes from '@images/illustrations/notes.svg';
import Experts from '@images/illustrations/experts.svg';

/* -----------------------  Bundle ------------------ */
const BUNDLE = {
  id: 7,
  title: 'USMLE Step 1 Flashcards',
  publisher: 'Memorang',
  icon: Logo7,
  categories: ['Medical'],
  nextBundles: [9, 10, 11, 12, 13],
  userAccess: {
    canStudy: false,
    canTrial: true,
    trial: null,
    subscription: null,
  },
  billingPlans: [
    {
      id: 1,
      duration: 3,
      interval: 'month',
      price: 49.99,
      currency: 'USD',
    },
    {
      id: 2,
      duration: 12,
      interval: 'month',
      price: 99.99,
      currency: 'USD',
    },
  ],
  trial: {
    duration: 7,
    interval: 'day',
    price: 0,
  },
  info: {
    tagline: 'Helped me memorize everything from First Aid and Pathoma',
    description:
      'Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet Lorem ipseum dolor sit amet',
    screenshots: [
      {
        src: 'https://source.unsplash.com/2ShvY8Lf6l0/800x599', caption: 'Learn anything',
      },
      {
        src: 'https://source.unsplash.com/Dm-qxdynoEc/800x799', caption: 'Remember more',
      },
      {
        src: 'https://source.unsplash.com/qDkso9nvCg0/600x799', caption: 'Create flashcards',
      },
      {
        src: 'https://source.unsplash.com/iecJiKe_RNg/600x799', caption: 'Study schedule',
      },
      {
        src: 'https://source.unsplash.com/epcsn8Ed8kY/600x799', caption: 'Learn anything',
      },
      {
        src: 'https://source.unsplash.com/NQSWvyVRIJk/800x599', caption: 'Learn anything',
      },
    ],
    video: '',
    content: [
      { name: 'Biochemistry', type: 'folder' },
      { name: 'Immunology', type: 'folder' },
      { name: 'Microbiology', type: 'folder' },
      { name: 'Pathology', type: 'folder' },
      { name: 'Pharmacology', type: 'folder' },
      { name: 'Public Health Sciences', type: 'folder' },
      { name: 'Cardiovascular', type: 'folder' },
      { name: 'Endocrine', type: 'folder' },
      { name: 'Gastrointestinal', type: 'folder' },
      { name: 'Hematology and Oncology', type: 'folder' },
      { name: 'Musculoskeletal, Skin, and Connective Tissue', type: 'folder' },
      { name: 'Neurology and Special Senses', type: 'folder' },
      { name: 'Psychiatry', type: 'folder' },
      { name: 'Renal', type: 'folder' },
      { name: 'Reproductive', type: 'folder' },
      { name: 'Respiratory', type: 'folder' },
      { name: 'Rapid Review and High-Yield', type: 'folder' },
    ],
    attributes: [
      {
        name: 'Flashcards',
        num: 20600,
      },
      {
        name: 'Questions',
        num: 5000,
      },
      {
        name: 'Study Sets',
        num: 338,
      },
      {
        name: 'Practice Tests',
        num: 37,
      },
    ],
    features: [
      '20,600 flashcards',
      '5,000 practice questions',
      'Covers First Aid 2019 & Pathoma',
      'Updated weekly by experts',
      'Personalized study schedule',
      'Mobile apps with offline support',
      'Add custom flashcards, folders, & notes',
    ],
    testimonials: [
      'Beat my target score',
      'Literally the best thing ever',
      'Made memorization so easy',
      'I went from average to constant 95% on tests',
      'Feels like lighting my prefrontal cortex on fire',
    ],
  },
};

/* -----------------------  Categories ------------------ */
const CATEGORIES = [
  {
    name: 'Medical',
    bundles: [
      {
        id: 7,
        name: 'USMLE Step 1',
        publisher: 'Memorang',
        icon: Logo7,
      },
      {
        id: 9,
        name: 'USMLE Step 2 CK',
        publisher: 'Med School Tutors',
        icon: Logo9,
      },
      {
        id: 8,
        name: 'ECGenius',
        publisher: 'Memorang',
        icon: Logo8,
      },
      {
        id: 10,
        name: 'MCAT Flashcards',
        publisher: 'Memorang',
        icon: Logo10,
      },
      {
        id: 11,
        name: 'NCLEX Flashcards',
        publisher: 'Memorang',
        icon: Logo11,
      },
      {
        id: 9,
        name: 'USMLE Step 2 CK',
        publisher: 'Med School Tutors',
        icon: Logo9,
      },
      {
        id: 8,
        name: 'ECGenius',
        publisher: 'Memorang',
        icon: Logo8,
      },
      {
        id: 10,
        name: 'MCAT Flashcards',
        publisher: 'Memorang',
        icon: Logo10,
      },
      {
        id: 11,
        name: 'NCLEX Flashcards',
        publisher: 'Memorang',
        icon: Logo11,
      },
      {
        id: 73,
        name: 'USMLE Step 1',
        publisher: 'Memorang',
        icon: Logo7,
      },
    ],
  },
  {
    name: 'Allied Health',
    bundles: [
      {
        id: 71,
        name: 'USMLE Step 1',
        publisher: 'Memorang',
        icon: Logo10,
      },
      {
        id: 71,
        name: 'SAT',
        publisher: 'Memorang',
        icon: Logo11,
      },
      {
        id: 71,
        name: 'GRE',
        publisher: 'Memorang',
        icon: Logo7,
      },
      {
        id: 71,
        name: 'LSAT',
        publisher: 'Memorang',
        icon: Logo8,
      },
      {
        id: 71,
        name: 'HESI',
        publisher: 'Memorang',
        icon: Logo9,
      },
    ],
  },
  {
    name: 'Test Prep',
    bundles: [
      {
        id: 71,
        name: 'NCLEX',
        publisher: 'Memorang',
        icon: Logo9,
      },
      {
        id: 71,
        name: 'NBDE I',
        publisher: 'Memorang',
        icon: Logo7,
      },
      {
        id: 71,
        name: 'NPTE',
        publisher: 'Memorang',
        icon: Logo8,
      },
      {
        id: 71,
        name: 'DAT',
        publisher: 'Memorang',
        icon: Logo11,
      },
      {
        id: 71,
        name: 'NAPLEX',
        publisher: 'Memorang',
        icon: Logo10,
      },
    ],
  },
];

/* -------------------  Frequently Asked Questions ------------------ */
const QUESTIONS = [
  {
    prompt: 'What is Memorang?',
    answer:
      'Memorang is a powerful, free web and mobile study tool for mastering and retaining knowledge for any subject. Free content such as flashcards and folders comes from two places: (1) Anything you create, upload, or collaborate on and (2) Anything made public by other learners around the world. You can also upgrade your account with premium Study-Packs!',
  },
  {
    prompt: 'What is a Study-Pack?',
    answer:
      'Study-Packs contain premium test-prep content authored by experts. These high-quality flashcards, practice questions, and folders are designed to help you focus on the important knowledge to ace your exams. When you subscribe to a Study-Pack, you have the freedom to reorganize the content alongside your coursework and personal flashcards. This allows you to use Memorang as an integrated study tool rather than just an external resource.',
  },
  {
    prompt: 'Who are the authors?',
    answer:
      'Each Study-Pack was authored by experts who follow rigorous content-guidelines while fact-checking and updating the material regularly throughout the year. This makes sure that you will always master the most up-to-date information.',
  },
  {
    prompt: 'What makes Study-Packs better than community content?',
    answer:
      'Study-Packs are designed to (1) Save you hundreds of hours of time; (2) Focus you exactly on what you need to know to rock your exams; and (3) Provide a study backbone that you can organize and integrate and add alongside your personal flashcards, notes, and coursework.',
  },
  {
    prompt: 'How does the study schedule and spaced repetition work?',
    answer:
      'Create a study schedule by setting a goal for what content you need to know, when you need to know it by, and how much time you have per day to study. You\'ll then be assigned a simple, daily stream of learning tasks for you to complete on any device. Memorang uses artificial intelligence and spaced repetition to calculate what you need to review next and what you’re at risk of forgetting. There’s no better way to save time and stay on track.',
  },
  {
    prompt: 'What is your 100% passing guarantee?',
    answer:
      'We are so confident that Memorang works that we will give you 100% of your money back if you don\'t pass your exam. The only requirement is that you follow our advice: Create a personalized study schedule from the Study-Pack and master at least 90% of the flashcards and questions contained within it. If you don\'t pass your exam, we will give you 100% of your money back or grant you another year of complimentary access - your choice.',
  },
  {
    prompt: 'What is your refund policy?',
    answer:
      'Memorang offers free trials to fully experience each Study-Pack so all purchases are final. If there is an issue with your account or premium content, please contact support and we will resolve the issue ASAP. The only exception to this policy is our 100% passing guarantee.',
  },
  {
    prompt: 'What happens when my plan expires? Can I extend it?',
    answer:
      'When your plan to a Study-Pack expires, you lose the ability to study any of its contents. If you need more time to study for your exam, you can add time by purchasing a plan extension.',
  },
  {
    prompt: 'Does my plan cover all Study-Packs or just one?',
    answer:
      'Each Study-Pack on Memorang is a different product that is purchased and priced separately',
  },
  {
    prompt: 'Do you have discounts available?',
    answer:
  <>
    <span>
      Yes! Our goal is to make high-quality learning available to everyone
      regardless of financial circumstance. Discounted and free Study-Packs
      are available for individuals, groups, and via faculty.
    </span>
    <a href="/mentors" style={{ paddingLeft: 4 }}>
      Read more about it here.
    </a>
  </>,
  },
];

/* -----------------------  Features ------------------ */
// const HERO_TITLE = 'Premium Study-Pack Store';
// const HERO_TITLE = 'Premium Study-Packs';
const HERO_TITLE = 'Ace your exams with premium Study-Packs';

const FEATURES = [
  {
    title: 'Trusted Content',
    subtitle: 'Authored by experts, updated weekly',
    image: Experts,
  },
  {
    title: 'Custom Study Schedule',
    subtitle: 'Save time with powerful spaced repetition',
    image: Calendar,
  },
  {
    title: 'Study Everywhere',
    subtitle: 'Web & mobile apps with real-time sync', // TODO: Change to "offline" once we add that feature
    image: Devices,
  },
  {
    title: 'Create & Annotate',
    subtitle: 'Add flashcards, study folders, and notes',
    image: Notes,
  },
];

/* -------------------exports----------------------- */
export {
  BUNDLE,
  CATEGORIES,
  FEATURES,
  QUESTIONS,
  HERO_TITLE,
};
